import Logger from '@tcp-base/toolkit';
import { useTokenStore } from '../stores/Token.store';
import { getDatabase } from './Auth.db';
import { useUserStore } from '../stores/User.store';

/**
 * Initialize the auth database and hydrate stores
 * This must complete before the app renders to ensure stores are ready
 */
export const initializeAuthDb = async (): Promise<void> => {
  try {
    Logger.log('AuthDB: Starting database initialization...');

    // Wait for database to open
    await getDatabase();
    Logger.log('AuthDB: Database opened successfully');

    // Fetch token details from IndexedDB and hydrate Zustand
    const { getTokenDetails } = useTokenStore.getState();
    const tokenDetails = await getTokenDetails();
    Logger.log(
      'AuthDB: Token details loaded:',
      tokenDetails.access_token ? 'Token found' : 'No token',
    );

    // Fetch user data from IndexedDB and hydrate Zustand
    const { getUserData } = useUserStore.getState();
    const userData = await getUserData();
    Logger.log(
      'AuthDB: User data loaded:',
      userData.email || userData.given_name ? 'User data found' : 'No user data',
    );

    Logger.log('AuthDB: Initialization complete');
  } catch (error) {
    Logger.error('Failed to initialize auth database:', error);
    throw error; // Re-throw to prevent app from loading if initialization fails
  }
};

export default initializeAuthDb;
